export const PoemGraphPaperMoment = () => {
    return (
        <div id="046" className="">
            <p>it feels like there's zero degrees out today.</p>
            <p>no heating. i'm in the living room and it is freezing.</p>
            <p>do you ever just surrender yourself to the cold?</p>
            <p>pale sunlight filters through layers of clothes</p>
            <p>i hanged out on the balcony.</p>
            <p>the light does nothing to heat up the room,</p>
            <p>the clothes are far from dry as well.</p>
            <p>there might be an unknown</p>
            <p>variable of guilt in this whole equation.</p>
            <br />
            <p>why face the cold unless</p>
            <p>you maybe feel like you deserve to,</p>
            <p>is this what's happening?</p>
            <p>i ask myself as if i wasn't the one writing this.</p>
            <p>it's harder to get what you feel like you don't deserve.</p>
            <p>some things seem impossibly distant </p>
            <p>because you feel like they should be,</p>
            <p>graph paper moment,</p>
            <p>the body stops before performing the action,</p>
            <p>it calculates the price of the transaction</p>
            <p>and finds itself unable to pay. math for misfits.</p>
            <p>define 'penance'. write it out as a function</p>
            <p>given x equal to yesterday's mishaps -</p>
            <p>wait,</p>
            <p>where did you even</p>
            <p>learn this from?</p>
        </div>
    );
};
